export const appConfig = {
  sessionName: "aitb01sess", // 사이트마다 달라야 함
  rememberidSSName: "aitblogin", // 사이트마다 달라야 함
  showTerms: false, // true : 사용자로그인, false : H-ART 로그인
  seed: "iogj43t459-d;lhgmrtmhl;kgrgju34t9urgj0gkb903-39t034gjg45",
  sessionTimeout: 1000 * 60 * 60 * 3, // 180분
};

// export const tenantKey = "53e63e64-8de5-4891-ab8d-332e14a8f337";